<template>
    <component-loader v-if="plantDetailsLoading" />
    <div v-else-if="props.selectedProject.projectBlocked">
        <div class="project-panel-wrapper">
            <div class="title-row-grid">
                <div class="project-title">
                    <h2>You do not have access to this project's details. Please select another</h2>
                </div>
            </div>
        </div>
    </div>
    <project-panel v-else-if="fullAssetTrackingProjectDetails !== null" :selectedProject="fullAssetTrackingProjectDetails" />
</template>

<script setup lang="ts">

import { ICsvData } from '@/interfaces/storageTracking/ICsvData.ts';
import { ref, watch } from 'vue';
import { useToast } from 'primevue/usetoast';
import ComponentLoader from '@/components/layout/ComponentLoader.vue';
import { DataApi } from '@/api/storageTracking/DataApi.ts';
import { IRedactedProjectData } from '@/interfaces/storageTracking/IRedactedProjectData.ts';
import ProjectPanel from './ProjectPanel.vue';

const props = defineProps<{ selectedProject: IRedactedProjectData }>();
const toast = useToast();

const fullAssetTrackingProjectDetails = ref<ICsvData | null>(null);

const plantDetailsLoading = ref<boolean>(false);

async function initialise (): Promise<void> {
    plantDetailsLoading.value = true;
    try {
        fullAssetTrackingProjectDetails.value = await DataApi.getProjectById(props.selectedProject.factStorageId);
    } catch (error) {
        toast.add({
            summary: 'Unable to retrieve plant details',
            severity: 'warn',
            detail: error,
            life: 10000,
        });
    } finally {
        plantDetailsLoading.value = false;
    }
}

initialise();

watch(() => props.selectedProject, async () => {
    await initialise();
});

</script>

<style lang="scss" scoped>

</style>
